import ErrorWrapper from './error-wrapper';
import { useLocation } from 'react-router-dom';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';

export default function ErrorMessagePage() {
  const location = useLocation();

  type LocationState = {
    messageSubject?: string;
    messageBody?: string;
  } | null;

  const state = location.state as LocationState;
  const messageSubject = state?.messageSubject || 'Suspended Subscription';
  const messageBody =
    state?.messageBody || 'Your subscription has been suspended.';

  return (
    <ErrorWrapper>
      <Card variant="outlined" sx={{ maxWidth: 920, zIndex: 2, px: 4, py: 6 }}>
        <CardHeader title={messageSubject} subheader={messageBody} />
      </Card>
    </ErrorWrapper>
  );
}
